<template>
	<!-- 主页面 -->
	<div class="home" @click="timeMousemove">
		<div class="homePC">
			<!-- 侧导航 -->
			<div class="homePC-side" :class="isCollapse ? 'homePC-side-width' : ''" :style="sideStyle">
				<div class="homePC-side-nav">
					<div class="homePC-side-logo">
						<div class="homePC-side-logo-text"><img src="../../assets/images/logo/HF.png" alt=""><span
								v-if='isCollapse == false'>飞砂走石</span></div>
					</div>
					<el-menu :default-active="this.$route.path" @select="twoSelet" :collapse='isCollapse' router
						class="homePC-side-nav-ul" @open="handleOpen" @close="handleClose" background-color="#fff"
						text-color="#333" active-text-color="#4DB5FF">
						<el-menu-item v-for="(item, index) in twoNavlist" :key="item.PERTB001ID" style="font-size: 16px;" :index="item.PERTB001CA03">
								<i class="el-icon-menu"></i>
								<span slot="title">{{ item.PERTB001CA00 }}</span>
							</el-menu-item>
					</el-menu>
				</div>
				<div class="homePC-side-btn pulic_cursor" :class="isCollapse ? 'homePC-side-btn-left' : ''"
					@click="iscoll">
					<span class="el-icon-arrow-left" v-if="isCollapse == false"></span>
					<span class="el-icon-arrow-right" v-if="isCollapse == true"></span>
				</div>

			</div>
			<!-- 右边主题内容 -->
			<div class="homePC-content">

				<div class="homePC-content-title">
					<div class="homePC-content-title-nav">
						<el-menu class="oneLevelSty" :default-active="oneNavDefActive" mode="horizontal"
							@select="handleSelect">
							<el-menu-item v-for="item in oneNavlist" :key="item.PERTB001ID" :index="item.PERTB001CA03">{{ item.PERTB001CA00
								}}
								</el-menu-item>
						</el-menu>
					</div>
					<div class="homePC-content-title-btn">
						<div class="homePC-content-title-btn-headerPro pulic_cursor">
							<div>
								<img src="../../assets/images/heaPortrait/Headportrait.png" alt="">
							</div>
						</div>
						<el-popover placement="bottom" width="200px" trigger="click" @show="queryaccount">
							<div slot="reference" class="homePC-content-title-btn-text pulic_cursor">
								<p>{{ userName }}</p>
								<p>{{ $store.state.uobj.enterpriseName || '飞砂走石云平台' }}</p>
							</div>
							<div class="homePC-content-title-account">
								<el-divider>切换账号</el-divider>
								<template v-for="(item, index) in accountList">
									<el-tooltip :key="index" class="item" effect="dark"
										:content="item.enterpriseName ? item.enterpriseName : '郑州小石头'"
										placement="bottom">
										<div class="homePC-content-title-account-li public-hover pulic_cursor"
											:class="erpId == item.pertb005.pertb005cd01 ? 'homePC-content-title-account-li-color' : ''"
											@click="switchAccount(item)">
											{{ item.enterpriseName ? item.enterpriseName : '郑州小石头' }}
										</div>
									</el-tooltip>
								</template>
							</div>
						</el-popover>
						<div class="homePC-content-title-btn-icon pulic_cursor" @click="outClick">
							<span class="el-icon-switch-button"></span>
						</div>
						<div class="public-dialog">
							<el-dialog title="个人信息" :visible.sync="personalInformation" width="30%">
								<div class="systemUserPC-add-user">
									<div class="systemUserPC-add-user-table">

										<div class="systemUserPC-add-user-li">
											<div>姓名</div>
											<div>
												<input type="text" value="" maxlength="16" v-model="modifyNameHome" />
											</div>
											<div>*必填*</div>
										</div>

										<div class="systemUserPC-add-user-li">
											<div>登录方式</div>
											<div>
												<el-select v-model="modifyLoginMethod">
													<el-option v-for="item in modifyLoginMethodList" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</div>
											<div>*必填*</div>
										</div>
									</div>
									<div class="systemUserPC-add-user-btn">
										<el-button type="primary" @click="modifyPersonalInformation">保存</el-button>
										<el-button type="warning" @click="cancelPersonalInformation">取消</el-button>
									</div>
								</div>
							</el-dialog>
						</div>
					</div>
				</div>
				<div class="homePC-content-lable">
					<div class="homePC-content-lable-tabs" :style="tabsStyle">
						<el-tabs v-model="$store.state.setHistTabsValue" type="card" closable @tab-remove="removeTab"
							@tab-click="tabClick">
							<el-tab-pane v-for="(item, index) in $store.state.tablist" :key="index" :label="item.PERTB001CA00"
									:name="item.PERTB001CA03">
								</el-tab-pane>
						</el-tabs>
					</div>
					<div class="homePC-content-lable-btn">
						<el-popover placement="bottom" width="130" trigger="click">
							<span slot="reference" class="homePC-content-lable-btn-ico iconfont icon-xiangxia"></span>
							<div class="homePC-content-lable-btn-COT">
								<ul>
									<li @click="downCurrent">关闭当前标签页</li>
									<li @click="downOther">关闭其它标签页</li>
									<li @click="downAll">关闭全部标签页</li>
								</ul>
							</div>
						</el-popover>
					</div>
				</div>
				<div v-show="show" class="homePC-content-router">
					<router-view />
				</div>
			</div>
			<audio id="music1" style="display: none;">
				<source src="../../assets/images/order.wav">
			</audio>
		</div>
	</div>
</template>

<script>
export default {

	data() {
		return {
			tabsStyle: '',
			sideStyle: '',
			isCollapse: false,
			pertb001List: '',
			oneNavlist: [],
			twoNavlist: [],
			oneNavDefActive: '',
			uobj: '',
			userName: '',
			imgSrc: '../../assets/images/heaPortrait/Headportrait.png',
			accountList: [],
			lastTime: null, // 最后一次移动的时间
			currentTime: null, // 当前点击的时间
			timeOut: 8 * 60 * 60 * 1000, // 设置超时时间:30分钟
			erpId: '',
			// 个人信息
			personalInformation: false,
			modifyNameHome: '',
			modifyLoginMethod: '',
			modifyLoginMethodList: [{
				value: 'MM',
				label: '密码'
			},
			{
				value: 'YZM',
				label: '验证码'
			},
			],
			show: true,
			socket: null,
			// 审核
			InvenAuditCountAll: 0, //充值审核
			DispatchAuditCountAll: 0, //销售派单审核
			TopUpAuditCountAll: 0, //销售充值审核
		}
	},
	mounted() {
		var tabsW = document.querySelector('.homePC-content-lable-tabs').clientWidth - 60
		var windowH = window.innerHeight
		this.tabsStyle = `width:${tabsW}px`
		this.sideStyle = `min-height:${windowH}px`
		this.isTimeOut()
		if (this.$store.state.uobj.pertb005.pertb005cb00 == 'CUS-1') {
			this.queryDispatchAuditHome()
		}

	},
	created() {
		this.lastTime = new Date().getTime()
		this.initNav()
		this.erpId = this.$store.state.uobj.pertb005.pertb005cd01

	},
	updated() {
		window.addEventListener('beforeunload', (e) => {
			var obj = {
				oneNavDefActive: this.oneNavDefActive,
				editableTabsValue: this.$store.state.setHistTabsValue,
				editableTabs: this.$store.state.tablist
			}
			this.$store.commit('setNavHistoy', obj)
			if (this.$store.state.tablist.length > 0) {
				sessionStorage.setItem('HistoyLObj', JSON.stringify(this.$store.state))
			}
		})
	},
	methods: {
		// 查询个人登录信息
		querypersonalClick() {
			this.personalInformation = true
			this.querypersonalPost()
		},
		querypersonalPost() {
			var url = "/per/pertb005/selectPertb005ById"
			var data = {
				PERTB005ID: this.$store.state.uobj.pertb005.pertb005id,
			}
			this.axios.post(url, data).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					var data = res.data.data
					this.modifyNameHome = data['PERTB005CA02']
					if (data['PERTB005CA04'] == 'MM') {
						this.modifyLoginMethod = this.modifyLoginMethodList[0]["value"];
					} else if (data['PERTB005CA04'] == 'YZM') {
						this.modifyLoginMethod = this.modifyLoginMethodList[1]["value"];
					}

				} else {
					this.$message({
						type: 'error',
						message: res.data.message
					});
				}
			})
		},
		cancelPersonalInformation() {
			this.personalInformation = false
		},

		queryDispatchAuditHome() { //待审核条数比对
			var postData = {
				ORMTB440CA02: this.$store.state.uobj.pertb005['pertb005cd01'], //一级企业id
			}
			var url = "/orm/ormtb440/remind";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 201) {
					// this.closeMp3DispatchHome()
					// this.noticeDispatchHome();
					console.log()
				}
			});
			setTimeout(() => {
				this.queryDispatchAuditHome()
			}, 60000);
		},
		// 提示音
		closeMp3DispatchHome() {
			var audio = document.getElementById('music1');
			if (audio.paused) {
				audio.play(); // 播放
			} else {
				audio.pause(); // 暂停
			}
		},
		// 有新待审核通知框
		// noticeDispatchHome() {
		// 	const h = this.$createElement;
		// 	this.$notify({
		// 		title: '销售派单通知',
		// 		message: h('i', {
		// 			style: 'color: red'
		// 		}, '您有新的销售派单，请尽快审核！！！'),
		// 		position: 'bottom-right',
		// 		duration: 15000
		// 	});
		// },
		// 修改个人信息
		modifyPersonalInformation() {
			// console.log(this.modifyNameHome)
			// console.log(this.modifyLoginMethod)
			if (this.modifyNameHome == '') {
				this.$message({
					message: "姓名不能为空",
					type: "error",
				});
			} else if (this.modifyLoginMethod == '') {
				this.$message({
					message: "登录方式不能为空",
					type: "error",
				});
			} else {
				this.modifyPersonalInPost();
			}
		},
		modifyPersonalInPost() {
			let loading = this.$loading({
				lock: true,
				text: "请求中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.5)",
			});
			var postData = {
				PERTB005CA02: this.modifyNameHome, //用户姓名
				PERTB005CA04: this.modifyLoginMethod, //登录方式（MM密码YZM验证码）
				PERTB005ID: this.$store.state.uobj.pertb005.pertb005id,
			};
			var url = "/per/pertb005/updatePertb005ById";
			this.axios.post(url, postData).then((res) => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$alert(`修改成功需退出重新登录？`, '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.$router.push('/Login');
						},
					});
				} else {
					this.$message({
						message: res.data.message,
						type: "error",
					});
				}
				setTimeout(() => {
					loading.close();
				}, 300);
			})
				.catch(() => {
					loading.close();
				});
		},
		queryaccount() { //获取账号
			this.accountList = []
			var url = "/system/login/queryOtherAccount"
			var data = {
				PERTB005CA03: this.$store.state.uobj.pertb005.pertb005ca03,
				PERTB005CB00: this.$store.state.uobj.pertb005.pertb005cb00,
				PERTB005CD01: this.$store.state.uobj.pertb005.pertb005cd01
			}
			this.axios.post(url, data).then(res => {
				// console.log(res)
				if (res.data.code == 200) this.accountList = res.data.data || []
			})
		},
		switchAccount(item) { //切换账号
			this.$confirm(`请确认是否切换账号：${item.enterpriseName ? item.enterpriseName : '小石头'}`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.upaccount(item)
			}).catch(() => {

			});
		},
		handleOpen(key, keyPath) { //侧导航展开
		},
		handleClose(key, keyPath) { //侧导航收起
		},
		handleSelect(key, keyPath) { //一级选中
			var newoBj = {}
			var newArr = []
			this.oneNavDefActive = keyPath[0]
			this.oneNavlist.forEach(resitem => {
				if (keyPath[0] == resitem.PERTB001CA03) {
					newoBj = resitem
				}
			})
			newoBj.childMenus.forEach(resitem1 => {
				newArr.push(resitem1)
			})
			this.twoNavlist = newArr
			this.$router.push(this.twoNavlist[0].PERTB001CA03)
			// this.editableTabs=[]
			this.twoNavlist.forEach(resitem2 => {
				if (this.twoNavlist[0].PERTB001CA03 == resitem2.PERTB001CA03) {
					var str = JSON.stringify(this.$store.state.tablist)
					var index = str.indexOf(this.twoNavlist[0].PERTB001CA03)
					if (index == -1) {
						var Stablsit = this.$store.state.tablist.slice()
						Stablsit.push(resitem2)
						this.$store.commit('upEditableTabs', Stablsit)
					}
				}
			})
			this.$store.commit('setHistTabsValue', this.twoNavlist[0].PERTB001CA03)
		},
		twoSelet(key, keyPath) { //二级选中
			this.twoNavlist.forEach(resitem => {
				if (keyPath[0] == resitem.PERTB001CA03) {
					let pathList = ['/Home/chargingOrder', '/Home/alarmInformation'];//带参数的菜单路径,单独处理
					if (pathList.indexOf(keyPath[0]) != -1) {
						let tabList = this.$store.state.tablist
						const tabIndex = tabList.findIndex(
							item => item.PERTB001CA05 === resitem.PERTB001CA05
						)
						if (tabIndex !== -1) {
							tabList.splice(tabIndex, 1) //移除已存在
						}
					}
					var str = JSON.stringify(this.$store.state.tablist)
					var index = str.indexOf(keyPath[0])
					if (index == -1) {
						var Stablsit = this.$store.state.tablist.slice()
						Stablsit.push(resitem)
						this.$store.commit('upEditableTabs', Stablsit)
						sessionStorage.removeItem(keyPath[0])
					}
				}
			})
			this.$store.commit('setHistTabsValue', keyPath[0])
		},
		removeTab(targetName) { //关闭历史标签页
			sessionStorage.removeItem(targetName)
			let tabs = this.$store.state.tablist;
			let activeName = this.$store.state.setHistTabsValue;
			if (activeName === targetName) {
				tabs.forEach((tab, index) => {
					if (tab.PERTB001CA03 === targetName) {
						let nextTab = tabs[index + 1] || tabs[index - 1];
						if (nextTab) {
							activeName = nextTab.PERTB001CA03;
						}
					}
				});
			}
			this.$store.commit('setHistTabsValue', activeName)
			this.$store.state.tablist = tabs.filter(tab => tab.PERTB001CA03 !== targetName);
			if (this.$store.state.tablist.length == 0) {
				var Stablsit = this.$store.state.tablist.slice()
				Stablsit.push(this.twoNavlist[0])
				this.$store.commit('upEditableTabs', Stablsit)
				this.$store.commit('setHistTabsValue', this.twoNavlist[0].PERTB001CA03)
			} else {
				let pertb001List = this.$store.state.uobj.pertb001List
				pertb001List.forEach(resitem => {
					resitem.childMenus.forEach(resitem1 => {
						if (this.$store.state.setHistTabsValue == resitem1.PERTB001CA03) {
							this.twoNavlist = resitem.childMenus
							this.oneNavDefActive = resitem.PERTB001CA03
						}
					})
				})
			}
			this.$router.push(this.$store.state.setHistTabsValue)
		},
		tabClick(target) { //切换历史标签页
			this.$router.push(target.name)
			this.$store.commit('setHistTabsValue', target.name)
			let pertb001List = this.$store.state.uobj.pertb001List
			pertb001List.forEach(resitem => {
				resitem.childMenus.forEach(resitem1 => {
					if (target.name == resitem1.PERTB001CA03) {
						this.twoNavlist = resitem.childMenus
						this.oneNavDefActive = resitem.PERTB001CA03
					}
				})
			})
		},
		downCurrent() { //关闭当前
			sessionStorage.removeItem(this.$store.state.setHistTabsValue)
			this.removeTab(this.$store.state.setHistTabsValue)
		},
		downOther() { //关闭其他
			var arr = []
			this.$store.state.tablist.forEach(resitem => {
				if (resitem.PERTB001CA03 == this.$store.state.setHistTabsValue) {
					arr.push(resitem)
				} else {
					sessionStorage.removeItem(resitem.PERTB001CA03)
				}
			})
			this.$store.commit('upEditableTabs', arr)
			this.$router.push(this.$store.state.setHistTabsValue)
			let pertb001List = this.$store.state.uobj.pertb001List
			pertb001List.forEach(resitem => {
				resitem.childMenus.forEach(resitem1 => {
					if (this.$store.state.setHistTabsValue == resitem1.PERTB001CA03) {
						this.twoNavlist = resitem.childMenus
						this.oneNavDefActive = resitem.PERTB001CA03
					}
				})
			})
		},
		downAll() { //关闭全部
			this.$store.state.tablist.forEach(resitem => {
				sessionStorage.removeItem(resitem.PERTB001CA03)
			})
			// console.log(this.twoNavlist[0])
			this.$store.commit('upEditableTabs', [this.twoNavlist[0]])
			this.$store.commit('setHistTabsValue', this.twoNavlist[0].PERTB001CA03)
			this.$router.push(this.$store.state.setHistTabsValue)
			let pertb001List = this.$store.state.uobj.pertb001List
			pertb001List.forEach(resitem => {
				resitem.childMenus.forEach(resitem1 => {
					if (this.$store.state.setHistTabsValue == resitem1.PERTB001CA03) {
						this.twoNavlist = resitem.childMenus
						this.oneNavDefActive = resitem.PERTB001CA03
					}
				})
			})
		},
		iscoll() {
			this.isCollapse = !this.isCollapse
		},
		sockClose() {


			// console.log(this.socket.close())
			// this.socket.onclose = function(e) {
			// 	console.log(e); //监听关闭事件
			// };
		},
		// beforeDestroy() {
		// 	this.sockClose(); // 确保组件销毁前断开连接
		// },

		outClick() { //退出登录
			this.$confirm(`请确认是否退出登录？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// var url = '/system/logout'
				// this.axios.get(url).then((res) => {
				// console.log(res)
				// if (res.data.code == 200) {
				this.$router.push('/Login')
				sessionStorage.removeItem('token')
				// this.sockClose()
				this.$store.commit('setUser', '')
				this.$store.commit('setNavHistoy', '')
				this.$store.commit('setSole', '')
				this.$store.commit('upEditableTabs', [])
				this.$store.commit('setHistTabsValue', '')
				// this.$forceUpdate()
				location.reload()
				// }
				// }).catch(() => {
				// this.$router.push('/Login')
				// });
			}).catch(() => {

			});
		},
		initNav() { //初始化导航数据
			var HistoyLObj = JSON.parse(sessionStorage.getItem('HistoyLObj'))
			if (HistoyLObj != null) {
				this.$store.commit('setUser', HistoyLObj.uobj)
				this.$store.commit('setNavHistoy', HistoyLObj.NavHistoyLObj)
				this.$store.commit('setSole', HistoyLObj.solelist)
				this.$store.commit('upEditableTabs', HistoyLObj.tablist)
				this.$store.commit('setHistTabsValue', HistoyLObj.setHistTabsValue)
				sessionStorage.removeItem('HistoyLObj')
			}
			var list = this.$store.state.uobj.pertb001List
			this.userName = this.$store.state.uobj.pertb005.pertb005ca02
			var pertb005ca00 = this.$store.state.uobj.pertb005.pertb005ca00
			this.isFailure()
			var newArr = []
			list.forEach(resitem => {
				newArr.push(resitem)
				resitem.childMenus.forEach(resitem1 => {
					newArr.push(resitem1)
				})
			})
			this.$store.commit('setSole', newArr)
			this.pertb001List = this.$store.state.uobj.pertb001List
			this.oneNavlist = []
			this.twoNavlist = []
			if (this.pertb001List[0]['PERTB001CA03'] != 'systemSettings') {
				this.pertb001List[0].childMenus.forEach(resitem => {
					resitem.childMenus.forEach(item => {
						// console.log(item)
						// if(item.PERTB001CA03=='shtz'){//派单审核
						// 	this.SIAuditDispatchListHome();
						// 	this.queryDispatchAuditHome()
						// }
						// if(item.PERTB001CA03=='SIAuditShtz'){//库存审核
						// 	this.SIAuditListHome();
						// 	this.queryNewAuditHome()
						// }
						// if(item.PERTB001CA03=='salesTopUpAuditShtz'){//销售充值审核
						// 	this.STopUpAuditListHome();
						// 	this.queryTopUpAuditHome()
						// }
					})
				})
			}
			this.pertb001List.forEach(resitem => {
				this.oneNavlist.push(resitem)
			})
			this.twoNavlist = this.pertb001List[0].childMenus
			var NavHistoyLObj = this.$store.state.NavHistoyLObj
			if (NavHistoyLObj != '' && NavHistoyLObj.editableTabs.length > 0) {
				this.pertb001List.forEach(resitem => {
					if (NavHistoyLObj.oneNavDefActive == resitem.PERTB001CA03) {
						this.twoNavlist = resitem.childMenus
					}
				})
				this.oneNavDefActive = NavHistoyLObj.oneNavDefActive
				this.$router.push(NavHistoyLObj.editableTabsValue)
				this.editableTabs = NavHistoyLObj.editableTabs
				this.$store.commit('upEditableTabs', NavHistoyLObj.editableTabs)
				this.$store.commit('setHistTabsValue', NavHistoyLObj.editableTabsValue)
			} else {
				this.oneNavDefActive = this.oneNavlist[0].PERTB001CA03
				var Stablsit = this.$store.state.tablist.slice()
				Stablsit.push(this.twoNavlist[0])
				this.$store.commit('upEditableTabs', Stablsit)
				this.$store.commit('setHistTabsValue', this.twoNavlist[0].PERTB001CA03)
				this.$router.push(this.twoNavlist[0].PERTB001CA03)
			}
		},
		isFailure() { //顶号操作
			if (this.$route.path == '/Login') return
			this.axios.get(`system/keepLogin`).then(res => {
				if (res.data.code === 599) {
					if (this.$route.path == '/Login') return
					this.$alert('该账号已在其他地方登录，如非本人操作，请尽快修改密码！', '', {
						confirmButtonText: '确定',
						type: 'warning',
						showClose: false
					}).then(() => {
						this.$router.push('/Login')
						sessionStorage.removeItem('token')
						this.$store.commit('setUser', '')
						this.$store.commit('setNavHistoy', '')
						this.$store.commit('setSole', '')
						this.$store.commit('upEditableTabs', [])
						this.$store.commit('setHistTabsValue', '')
						location.reload()
					}).catch(() => { });
				} else {
					var that = this
					if (this.$route.path != 'Login') {
						setTimeout(function () {
							that.isFailure()
						}, 5000)
					}
				}
			}).catch(() => {
				this.$router.push('/Login')
				sessionStorage.removeItem('token')
				this.$store.commit('setUser', '')
				this.$store.commit('setNavHistoy', '')
				this.$store.commit('setSole', '')
				this.$store.commit('upEditableTabs', [])
				this.$store.commit('setHistTabsValue', '')
			});
		},
		upaccount(item) { //切换账号
			var url = '/system/login/logout'
			this.axios.get(url).then((res) => {
				if (res.data.code == 200) {
					this.$router.push('/Login')
				}
			}).catch(() => { });
			var url = '/system/login/secondlogin'
			var data = {
				username: item.pertb005.pertb005ca03,
				password: item.pertb005.pertb005ca01,
				PERTB005CB00: item.pertb005.pertb005cb00,
				PERTB005CD01: item.pertb005.pertb005cd01
			}
			this.axios.post(url, data).then((res) => {
				if (res.data.code == 200) {
					this.oneNavlist = []
					this.twoNavlist = []
					this.$store.commit('setUser', res.data.data)
					this.$store.commit('setNavHistoy', '')
					this.$store.commit('setSole', '')
					this.$store.commit('upEditableTabs', [])
					this.$store.commit('setHistTabsValue', '')
					sessionStorage.setItem('token', res.data.data.token)
					this.$router.push('/Home')
				} else {
					this.$message.error(res.data.message)
				}
			}).catch(() => {
				this.loading = false
			});
		},
		timeMousemove() { //更新最后操作时间
			this.lastTime = new Date().getTime()
		},
		isTimeOut() { //校验为操作时间
			this.currentTime = new Date().getTime() // 记录这次点击的时间
			if (this.$route.path == 'Login') return
			if (this.currentTime - this.lastTime >= this.timeOut) { // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
				if (sessionStorage.getItem('token')) { // 如果是登录状态
					var url = '/system/login/logout'
					this.axios.get(url).then((res) => {
						if (res.data.code == 200) {
							this.$router.push('/Login')
						}
					}).catch(() => { });
				}
			} else {
				setTimeout(() => {
					this.isTimeOut()
				}, 300000)
			}
		}
	}

}
</script>
<style scoped>
.homePC {
	display: flex;
	box-sizing: border-box;
}

.homePC-side {
	box-sizing: border-box;
	/* background-color: #545c64; */
	transition: all 10 cubic-bezier(.23, 1, .32, 1);
	-moz-transition: width .3s;
	/* Firefox 4 */
	-webkit-transition: width .3s;
	/* Safari 和 Chrome */
	-o-transition: width .3s;
	/* Opera */
}

.homePC-side:not(.homePC-side-width) {
	width: 180PX;
	box-sizing: border-box;
}

.homePC-side-width {
	width: 74PX;
	min-width: 74PX;
}

.homePC-side-nav {
	height: 95%;
	padding-bottom: 5PX;
}

.homePC-side-logo {
	overflow: hidden;
	border-bottom: solid 2px #e6e6e6;
}

.homePC-side-logo-text {
	width: 100%;
	line-height: 62px;
	/* background-color: rgba(67,74,80,1); */
	font-size: 20px;
	color: #333;
	padding: 0 0 0 20PX;
	box-sizing: border-box;
	vertical-align: middle;
}

.homePC-side-logo-text>img {
	height: 30px;
	width: 30px;
	margin-right: 10PX;
	vertical-align: middle;
}

.homePC-side-logo-img {
	padding: 20px 0 0 10px;
	background-color: #545c64;
}

.homePC-side-btn {
	position: fixed;
	top: 450px;
	color: #333;
	padding-bottom: 5px;
	vertical-align: top;
	overflow: hidden;
	box-sizing: border-box;
	width: 20px;
	height: 90px;
	line-height: 90px;
	/* background-color: rgba(25, 159, 255, .5); */
	background: url(../../assets/images/home/shallowScaling.png) no-repeat;
	background-size: 100% 100%;
	font-size: 20px;
	color: #FFF;
	text-align: center;
	z-index: 999;
	transition: left .2s;
	-moz-transition: left .2s;
	/* Firefox 4 */
	-webkit-transition: left .2s;
	/* Safari 和 Chrome */
	-o-transition: left .2s;
	/* Opera */
}

.homePC-side-btn:hover {
	background-color: rgba(25, 159, 255, 1);
	background: url(../../assets/images/home/scaling.png) no-repeat;
	background-size: 100% 100%;
}

.homePC-side-btn>div {
	font-size: 14px;
}

.homePC-side-nav-ul:not(.el-menu--collapse) {
	width: 180PX;
	height: 100%;
	overflow: hidden;
}

.homePC-side-btn:not(.homePC-side-btn-left) {
	left: 180PX;
	transition: left .3s;
	-moz-transition: left .3s;
	/* Firefox 4 */
	-webkit-transition: left .3s;
	/* Safari 和 Chrome */
	-o-transition: left .3s;
	/* Opera */
}

.homePC-side-btn-left {
	left: 74PX;
}

.homePC-content {
	position: relative;
	flex: 4;
	padding: 0 10px 0 10px;
	background-color: #F3F3F3;
	box-sizing: border-box;
	overflow-x: auto;
}

.homePC-content-title {
	display: flex;
	box-sizing: border-box;
}

.homePC-content-title-nav {
	flex: 4;
	/* height: 60px; */
	box-sizing: border-box;
}

.homePC-content-title-btn {
	height: 60px;
	padding-right: 33px;
	background-color: #FFF;
	box-sizing: border-box;
}

.homePC-content-title-account {
	width: 200px;
	padding: 0 10px;
	box-sizing: border-box;
}

.homePC-content-title-account .el-divider__text {
	width: 120px;
	font-size: 18px;
	text-align: center;
	box-sizing: border-box;
}

.homePC-content-title-account-li {
	height: 40px;
	line-height: 40px;
	font-size: 16px;
	padding: 0 20px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.homePC-content-title-account-li-color {
	color: rgba(25, 159, 255, 1);
}

.homePC-content-title-btn-headerPro {
	display: inline-block;
	margin-top: 10px;
	vertical-align: middle;
}

.homePC-content-title-btn-headerPro div {
	width: 32px;
	height: 32px;
	border-radius: 50%;
}

.homePC-content-title-btn-headerPro div>img {
	width: 100%;
	height: 100%;
}

.homePC-content-title-btn-text {
	display: inline-block;
	margin-left: 10px;
	margin-top: 10px;
	font-size: 14px;
	vertical-align: middle;
	color: #666666;
}

.homePC-content-title-btn-icon {
	display: inline-block;
	margin-left: 20px;
	margin-top: 10px;
	font-size: 25px;
	color: #333;
	vertical-align: middle;
}

.homePC-content-lable {
	margin-top: 1px;
	background-color: #FFF;
	display: flex;
	box-sizing: border-box;
}

.homePC-content-lable-tabs {
	flex: 4;
	width: 1500px;
	box-sizing: border-box;
}

.homePC-content-lable-btn {
	height: 41px;
	line-height: 41px;
	padding-right: 33px;
	box-sizing: border-box;
}

.homePC-content-lable-btn .homePC-content-lable-btn-ico {
	display: inline-block;
	width: 40px;
	height: 40px;
	border: 1px solid #f3f3f3;
	text-align: center;
	color: #666666;
	border-top-color: #f3f3f357 !important;
}

.homePC-content-lable-btn-COT {
	font-size: 14px;
	color: #666;
	text-align: center;
}

.homePC-content-lable-btn-COT>ul>li {
	line-height: 30px;
	padding: 0 12px;
}

.homePC-content-lable-btn-COT>ul>li:hover {
	background-color: #eee;
}

.homePC-content-router {
	background-color: #FFF;
}

.oneLevelSty li {
	padding: 0px 24px !important;
}

/* 个人信息 */
.systemUserPC-add-user {
	padding-left: 20px;
}

.systemUserPC-add-user-li {
	display: flex;
	height: 42px;
	line-height: 42px;
	text-align: center;
	font-size: 16px;
	color: #333;
}

.systemUserPC-add-user-li>div {
	flex: 1;
	border: 1px solid #CDCDCD;
	border-top: none;
}

.systemUserPC-add-user-li:first-child>div {
	border-top: 1px solid #CDCDCD;
}

.systemUserPC-add-user-li>div:last-child {
	flex: .3;
	border: none;
	color: #FF4D35;
}

.systemUserPC-add-user-li>div:first-child {
	border-right: none;
	background: rgba(240, 252, 255, 1);
}

.systemUserPC-add-user-li input {
	border: none;
	height: 100%;
	width: 100%;
	box-sizing: border-box;
	vertical-align: top;
	text-align: center;
	font-size: 16px;
}

.systemUserPC-add-user-btn {
	text-align: center;
	padding: 40px 0 20px 0;
}

/* 定义过渡样式 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active for <=2.1.8 */
	{
	opacity: 0;
}
</style>
